import $ from 'jquery';
import atlasLocationService from '~/app/javascript/src/services/atlas_location_service';
import '~/app/assets/javascripts/forked_libs/select2';
import '~/app/assets/javascripts/extensions/select2_custom_dropdown';
import iosFocusFix from '../utils/ios_focus_fix';

// Sorted by precision
const GEOLOCATION_METHODS = {
  postal_code: 'google_precise',
  route: 'google_precise',
  sublocality: 'google_neighborhood',
  administrative_area_level_2: 'google_city',
  locality: 'google_city',
};

const { _require } = window;

class LocationSelector {
  constructor(selector, options = {}) {
    this.$wrapper = $(selector);

    this.location = {
      city: this.$wrapper.data('city'),
      description: this.$wrapper.data('description'),
      geolocation_method: this.$wrapper.data('geolocation-method'),
      lat: this.$wrapper.data('lat'),
      lng: this.$wrapper.data('lng'),
      state: this.$wrapper.data('state'),
    };

    this.events = {
      change: [],
    };

    this.components = $('.js-select', this.$wrapper).select2({
      theme: options.theme || 'link-golden-m',
      placeholder: 'Cidade, endereço ou CEP',
      minimumInputLength: 3,
      maximumInputLength: 256,
      ajax: {
        delay: 1000,
        transport(params, success, failure) {
          const transportResult = {};
          atlasLocationService.getPlacePredictions(params.data.q).then(success).catch((error) => {
            if (error) {
              transportResult.status = error.status;
            }
            failure();
          });
          return transportResult;
        },
        processResults(data) {
          // WORKAROUND - prevents data.id data missing
          const newData = data.map(item => ({
            ...item,
            id: item.place_id,
          }));

          return {
            results: newData.filter(item => !item.types.find(type => (
              type === 'country' ||
              type === 'administrative_area_level_1' || // states
              type === 'point_of_interest' ||
              type === 'natural_feature' ||
              type === 'colloquial_area' ||
              type === 'establishment' ||
              type === 'premise'
            ))),
          };
        },
      },
      templateResult(item) {
        let result = atlasLocationService.cleanAddress(item.description || item.text);
        let offsetAcc = 0;

        if (item.matched_substrings) {
          item.matched_substrings.forEach((match) => {
            const matched = result.substr(match.offset + offsetAcc, match.length);
            offsetAcc -= result.length;
            result = result.replace(matched, `<span class="location-selector__matched">${matched}</span>`);
            offsetAcc += result.length;
          });
        }

        return $(`<div>${result}</div>`);
      },
      templateSelection(item) {
        return atlasLocationService.cleanAddress(item.description || item.text);
      },
    });

    // Fixes select2v3 removing select2v4 initial values
    this.components.removeClass('select2-hidden-accessible').addClass('hide');

    this.components.on('select2:opening', (e) => {
      if ($('.select2-container--open', this.$wrapper).length) {
        e.preventDefault();
      }
    });

    this.components.on('select2:open', (e) => {
      $('.select2-container--open').addClass('location-selector__select2-container');
      this.renderGeolocationBtn($(e.target));
      this.resetDropdownPosition();
    });

    this.components.on('select2:closing', () => {
      $('.select2-container--open').removeClass('location-selector__select2-container');
      this.clearExtraContent();
    });

    this.components.on('select2:select', (e) => {
      const result = e.params.data;

      this.geocodeFromPlace(result.place_id).then((location) => {
        const value = Object.assign({ description: result.description }, location);
        this.setValue(value);
        this.emit('change', value);
      }).catch(() => {
        // do nothing
      });
    });

    iosFocusFix(this.$wrapper);
  }

  on(eventName, cb) {
    if (this.events[eventName]) {
      this.events[eventName].push(cb);
    }
  }

  getValue() {
    return this.location;
  }

  setValue(value) {
    if (value && value.city && value.state) {
      this.location = value;
      this.components.empty();
      const text = value.description || `${this.location.city} - ${this.location.state}`;
      const newState = new window.Option(text, text, true, true);
      this.components.append(newState).trigger('change');
    } else {
      this.location = {};
      this.components.empty();
      this.components.trigger('change');
    }
  }

  resetDropdownPosition() {
    // Forces dropdown repositioning after the content insertion
    setTimeout(() => $(window).scroll());
  }

  emit(eventName, content) {
    const callbacks = this.events[eventName];
    if (callbacks) {
      callbacks.forEach(callback => callback(content));
    }
  }

  isOpen(select) {
    return $(select).next().hasClass('select2-container--open');
  }

  getDropdown() {
    return $('.select2-container--open .select2-dropdown');
  }

  clearExtraContent() {
    $('.js-extra-content', this.getDropdown()).remove();
  }

  fillExtraContent($content) {
    const $dropdown = this.getDropdown();
    $('.js-extra-content', $dropdown).remove();
    const $extraContent = $('<div class="js-extra-content location-selector__extra-content"><div class="js-or-message location-selector__or-message">Ou digite um local</div></div>');
    $extraContent.prepend($content);
    $dropdown.prepend($extraContent);
  }

  renderLoading($select) {
    const $loadingIcon = $('.js-loading-icon', $select.parent()).clone().removeAttr('class');
    const $loading = $('<div class="location-selector__loading"><div class="location-selector__loading-icon js-icon-wrapper anim-spin"></div><span class="location-selector__loading-text">Buscando sua localização...</span></div>');
    $('.js-icon-wrapper', $loading).prepend($loadingIcon);
    return this.fillExtraContent($loading);
  }

  renderUpperError($select, errorMessage) {
    const $warningIcon = $('.js-warning-icon', $select.parent()).clone().removeAttr('class');
    const $warning = $(`<div class="location-selector__warning"><div class="location-selector__warning-icon js-icon-wrapper"></div><span class="location-selector__warning-text">${errorMessage}</span></div>`);
    $('.js-icon-wrapper', $warning).prepend($warningIcon);
    this.fillExtraContent($warning);
    $('.js-or-message', this.getDropdown()).text('Digite um local');
  }

  renderGeolocationBtn($select) {
    const $geoIcon = $('.js-geo-icon', $select.parent()).clone().removeAttr('class');
    const $geolocationBtn = $('<a class="location-selector__geolocation-btn js-geolocation-btn"><div class="location-selector__geolocation-btn-icon js-icon-wrapper"></div><span class="location-selector__geolocation-btn-text">Encontre minha localização</span></a>');
    $('.js-icon-wrapper', $geolocationBtn).prepend($geoIcon);

    $geolocationBtn.click(() => {
      this.renderLoading($select);
      this.refreshCurrentPosition().then((location) => {
        this.setValue(location);
        $select.select2('close');
        return this.emit('change', location);
      }).catch(error => this.renderUpperError($select, error.message));

      _require(['metrics'], () => {
        const { trackable, Metrics } = window;
        trackable.eventTracker.track(Metrics.Events.ClickedGeolocationIcon, { path: document.location.pathname });
      });
    });

    return this.fillExtraContent($geolocationBtn);
  }

  geocode(lat, lng) {
    return atlasLocationService.geocode(lat, lng).then((results) => {
      const cityState = this.getLocation(results, false);

      if (!cityState) {
        throw new Error('Geocode without city or state');
      }

      const safePlace = results.find(location => (
        location.types.indexOf('street_address') === -1
        && location.types.indexOf('point_of_interest') === -1
      )) || results[0];

      return {
        lat,
        lng,
        city: cityState.city,
        state: cityState.state,
        description: atlasLocationService.cleanAddress(safePlace.formatted_address),
      };
    }).catch((error) => {
      const { Rollbar } = window;
      Rollbar.error('location_selector#geocode - Failed', {
        lat, lng, status: error.status, detail: error.message,
      });

      // renderUpperError joga isso no DOM: mensagem pro usuário, detalhe fica no Rollbar.
      throw new Error('Não foi possível encontrar sua localização.');
    });
  }

  refreshCurrentPosition() {
    return this.getBrowserLocation({ enableHighAccuracy: true }).then((position) => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      return this.geocode(lat, lng).then(location => Object.assign({}, location, { geolocation_method: 'browser' }));
    });
  }

  getBrowserLocation(positionOptions) {
    return new Promise((resolve, reject) => window.navigator.geolocation.getCurrentPosition(resolve, (error) => {
      let errorMessage;

      switch (error.code) {
        case 1:
          errorMessage = 'Permissão de localização negada.'; // PERMISSION_DENIED
          break;
        case 2:
          errorMessage = 'Posição desconhecida.'; // POSITION_UNAVAILABLE
          break;
        case 3:
          errorMessage = 'Tempo expirado para aceitar.'; // TIMEOUT
          break;
        default:
          errorMessage = 'Erro desconhecido na localização.';
      }

      _require(['metrics'], () => {
        const { trackable, Metrics } = window;
        trackable.eventTracker.track(Metrics.Events.BrowserLocationError, { error, errorMessage });
      });

      reject(new Error(errorMessage));
    }, positionOptions));
  }

  geocodeFromPlace(placeId) {
    return atlasLocationService.geocodeFromPlace(placeId).then(((details) => {
      const location = this.getLocation(details, true);

      if (!location || !location.city || !location.state) {
        const { Rollbar } = window;
        Rollbar.error('location_selector#getPlaceDetais - Missing data', {
          location,
          placeId,
          details,
        });

        throw new Error('Place details without city or state');
      }

      location.description = atlasLocationService.cleanAddress(details.formatted_address);

      return location;
    }));
  }

  getGeolocationMethod(types) {
    for (let i = 0; i < types.length; i += 1) {
      const precision = GEOLOCATION_METHODS[types[i]];
      if (precision) return precision;
    }

    return 'google';
  }

  getLocation(items, withGeolocationMethod) {
    const components = !(items instanceof Array) ? [items] : items;

    let result = null;
    let geolocationMethod = null;

    if (withGeolocationMethod) {
      geolocationMethod = this.getGeolocationMethod(items.types);
    }

    components.some((component) => {
      let city = null;
      let state = null;

      return component.address_components.some(address => address.types.some((type) => {
        if (type === 'administrative_area_level_2' || type === 'locality') { // City
          city = address.long_name;
        } else if (type === 'administrative_area_level_1') { // State
          state = address.short_name;
        }

        if (city && state) {
          const { location } = component.geometry;

          result = {
            lat: (typeof location.lat === 'function') ? location.lat() : location.lat,
            lng: (typeof location.lng === 'function') ? location.lng() : location.lng,
            city,
            state,
          };

          if (withGeolocationMethod) {
            result = Object.assign(
              result,
              { geolocation_method: geolocationMethod },
            );
          }

          return true;
        }

        return false;
      }));
    });

    return result;
  }
}

export default LocationSelector;
